import { Component } from 'react'
import styled from 'styled-components'
import Media from 'components/utils/Media'
import { connect } from 'react-redux'

import Modal from '../display/Modal'

import { fetchListing } from '../../actions/listingActions'
import { fetchListingFields } from '../../actions/listingFieldsActions'
import { fetchEnquiryPrices } from '../../actions/enquiryActions'

import CrossOutIcon from '../icons/CrossOut'
import CloseIcon from '../icons/AirbnbClose'
import LocationPinIcon from '../icons/LocationPin'

import BookingForm from '../../pages/listing/Booking/BookingForm'
import InvisibleButton from '../display/InvisibleButton'

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 900px;
`

const CloseButton = styled(InvisibleButton)`
  padding: 24px;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 800px) {
    svg {
      height: 40px;
      width: 40px;
    }
  }
`

const Header = styled.div`
  padding: 20px 0;

  color: white;
  text-align: right;

  @media (min-width: 768px) {
    padding-top: 40px;

    ${CloseButton} {
      padding-right: 0;
    }
  }
`

const Hero = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;

  width: 100%;

  color: white;

  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url(${({ backgroundImage }) => backgroundImage});

  @media (min-width: 800px) {
    flex-direction: row;
    align-items: flex-end;
    padding-top: 0;
  }

  ${CloseButton} {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
  }
`

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;

  width: 100%;
  padding: 20px;
  padding-right: 64px;

  @media (min-width: 800px) {
    padding: 48px;
  }

  section {
    padding: 0 0 20px 0;
    margin-bottom: 40px;
  }
`

const ModalContent = styled.div`
  position: relative;

  @media (min-width: 800px) {
    padding-bottom: 40px;
  }
`

const FormWrapper = styled.div`
  position: relative;
  margin-top: 24px;
  z-index: 9;
  color: #333;
  width: 100%;

  @media (max-width: 799px) {
    padding: 24px;
  }

  @media (min-width: 800px) {
    min-width: 330px;
    margin: 48px;
  }
`

const Title = styled.h1`
  font-size: 26px;
  line-height: 1;
  margin: 0;
  margin-bottom: 20px;

  @media (min-width: 800px) {
    font-size: 42px;
    max-width: 430px;
  }
`
const Details = styled.div`
  display: flex;
`

const Detail = styled.div`
  display: flex;
  font-size: 16px;
  align-items: center;
  margin-right: 10px;

  svg {
    height: 16px;
    margin-right: 6px;
  }
`

class QuickbookModal extends Component {
  componentDidMount() {
    const { dispatch, listingId } = this.props
    dispatch(fetchEnquiryPrices(listingId, undefined))

    dispatch(fetchListingFields()).then(() => {
      // The listing is usually already in the store (page load / SSR seed), so
      // skip the redundant full-listing fetch when it already holds this one.
      if (this.props.listing?.id?.toString() !== listingId?.toString()) {
        dispatch(fetchListing(listingId))
      }
    })
  }

  scrollBackTop = () => {
    if (document && document.querySelector) {
      const modal = document.querySelector('.js-quick-book')
      modal.scrollTo(0, 0)
    }
  }

  render() {
    const { listing, isOpen, storyId, onRequestClose, promoImage } = this.props

    if (!listing) return null

    return (
      <Modal
        className="c-fullscreen-modal__content qa-quick-book js-quick-book"
        overlayClassName="c-fullscreen-modal__overlay"
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <Container>
          <Media query="(min-width: 800px)">
            <Header>
              <CloseButton onClick={onRequestClose}>
                <CrossOutIcon />
              </CloseButton>
            </Header>
          </Media>

          <ModalContent>
            <Hero backgroundImage={promoImage}>
              <Media query="(max-width: 799px)">
                <CloseButton onClick={onRequestClose}>
                  <CloseIcon />
                </CloseButton>
              </Media>
              <ContentWrapper>
                <Title>{listing.title}</Title>
                <Details>
                  <Detail>
                    <LocationPinIcon />
                    {`${listing.city}, ${listing.state}`}
                  </Detail>
                </Details>
              </ContentWrapper>
              <FormWrapper>
                <BookingForm
                  listingId={listing.id}
                  listingBookable={listing?.bookable}
                  listingMarket={listing?.market}
                  storyId={storyId}
                />
              </FormWrapper>
              <HeroOverlay />
            </Hero>
          </ModalContent>
        </Container>
      </Modal>
    )
  }
}

export default connect(({ auth, enquiry, listing, listingFields }) => ({
  auth,
  enquiry,
  listing: listing.data && {
    ...listing.data,
    features: listing.features,
    amenities: listing.amenities,
    details: listing.details,
    pricing: listing.pricing,
  },
  listingFields,
}))(QuickbookModal)
